import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useEffect, useRef } from 'react';
import { MINDSET_OPEN_WITH_MESSAGE_EVENT, peekPendingOpenMessage, clearPendingOpenMessage } from 'utils/mindset';
export function useOpenMindsetWithMessageEvent(handleOpen) {
  // Guards against a re-entrant replay while handleOpen is still in flight -
  // its own state updates can change its identity and re-run this effect
  // before it resolves. A ref survives that re-run; a local variable wouldn't.
  var isHandlingRef = useRef(false);
  useEffect(function () {
    function handle(_x, _x2, _x3, _x4) {
      return _handle.apply(this, arguments);
    } // Replays a message dispatched before this listener registered (e.g. on
    // a cold page load), or one a previous, now-stale handleOpen declined
    // (e.g. the dock while hidden) - this effect re-runs whenever
    // handleOpen's identity changes, which happens as guard state
    // (isHiddenByPage, isDesktop, etc.) settles, giving this a natural retry.
    function _handle() {
      _handle = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(message, silent, threadTitle, coachingContext) {
        var accepted;
        return _regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!isHandlingRef.current) {
                _context.next = 1;
                break;
              }
              return _context.abrupt("return");
            case 1:
              isHandlingRef.current = true;
              _context.prev = 2;
              _context.next = 3;
              return handleOpen(message, silent, threadTitle, coachingContext);
            case 3:
              accepted = _context.sent;
              // Only clear the buffer if this call actually acted on it -
              // otherwise leave it in place for a later re-run (e.g. once
              // isHiddenByPage flips false) to retry.
              if (accepted) clearPendingOpenMessage();
            case 4:
              _context.prev = 4;
              isHandlingRef.current = false;
              return _context.finish(4);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[2,, 4, 5]]);
      }));
      return _handle.apply(this, arguments);
    }
    var pending = peekPendingOpenMessage();
    if (pending) {
      handle(pending.message, pending.silent, pending.threadTitle, pending.coachingContext);
    }
    function onOpenWithMessage(e) {
      var _detail = e.detail,
        message = _detail.message,
        silent = _detail.silent,
        threadTitle = _detail.threadTitle,
        coachingContext = _detail.coachingContext;
      handle(message, silent !== null && silent !== void 0 ? silent : false, threadTitle !== null && threadTitle !== void 0 ? threadTitle : '', coachingContext !== null && coachingContext !== void 0 ? coachingContext : '');
    }
    window.addEventListener(MINDSET_OPEN_WITH_MESSAGE_EVENT, onOpenWithMessage);
    return function () {
      return window.removeEventListener(MINDSET_OPEN_WITH_MESSAGE_EVENT, onOpenWithMessage);
    };
  }, [handleOpen]);
}